module.exports = __webpack_public_path__ + "img/speaker-small-close.cdd3c363.svg";